import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

export const getProviderPaymentSummary = createAsyncThunk("provdier/get-payment-summary", async ({ token, year }, thunkAPI) => {
  try {
    const res = await axios.get(
        `${BACKEND_URL}/provider/get-payment-summary?year=${year}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
    return res.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Failed to fetch providers payment summary");
  }
});

const providerDashboardSlice = createSlice({
     name: "providerDashboard",
     initialState: {
        revenueSplit: [],
        topServices: [],
        monthServices: [],
        aiSummary: [],
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
          builder
            .addCase(getProviderPaymentSummary.pending, (state) => {
                state.loading = true;
            })
            .addCase(getProviderPaymentSummary.fulfilled, (state, action) => {
                state.revenueSplit = action.payload.revenueSplit;
                state.topServices = action.payload.topServices;
                state.monthServices = action.payload.monthServices;
                state.aiSummary = action.payload.aiSummary;
                state.loading = false;
            })
            .addCase(getProviderPaymentSummary.rejected, (state, action) => {
                state.error = action.payload || "Failed to fetch providers payment summary"; 
                state.loading = false;
            })
    },
});

export default providerDashboardSlice.reducer;